module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAMVJREFUaEPtmMENwjAQBL0dUAIpgBKozdchJYQHf0ow8g9F/lh7joSYfJPsxePxybHKgisiLq2193e0pC0intnllB3Y8xjABFVmYAQLhVBoggAKmbDoQiiEQiYBFDIB0oVQCIVMAihkAlREXM2M0ev9p/5xuHGX9MqupVpryw49M48BnEl7VOv3Z6CfICyg2BfxfjiZu5VS8hfxgo/nZG4GKrtRthIzvgyeRSEUQiGTAAqZAOlCKIRCJgEUMgHShVDo3xX6AL0QZ2CwTiByAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/upload-icon.png
// module id = YiuI
// module chunks = 1